// appears on bottom for debt and on going only

import React from 'react';
import { withTranslation } from 'react-i18next';
import Parent from '../parent';
import InstallmentsBox from "./InstallmentsBox";
import {BllinkLogger} from "../utils/bllink_loggers";


export class MonthRelatedSelectBox extends Parent {
    render() {
        const rightClass = 'col-md-7';
        const leftClass = 'col-md-5';
        let defaultNumberOfInstallments = this.props.isOnGoing ? this.props.defaultInstallments : null;
        BllinkLogger.info(`MonthRelatedSelectBox props are `, this.props);

        return (
            <div className="form-content">
                <div className="row month-related-installment-box">
                    <div className={`${rightClass} w_set_sec_27`}/>
                    <div className={`${leftClass} w_set_sec_26`}>
                        <InstallmentsBox
                            months={this.props.months}
                            currency={this.props.currency}
                            maxNumberOfInstallments={this.props.maxNumberOfInstallments}
                            total={this.props.total}
                            name={this.props.name}
                            totalReward={this.props.totalReward}
                            //https://app.asana.com/0/1196545425570329/1198921803890861 for on going select the max by default
                            defaultNumberOfInstallments={defaultNumberOfInstallments}
                            selectedNumberOfInstallments={this.props.currentInstallments || null}
                            shouldHideCreditCardOption={this.props.shouldHideCreditCardOption}
                            isViewedAsManager={this.props.isViewedAsManager}
                            buildingID={this.props.buildingID}
                            apartmentNumber={this.props.apartmentNumber}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(MonthRelatedSelectBox);

